<template>
  <div class="banner-wrap">
    <div class="text" id="text1">从创业之初，</div>
    <div class="text" id="text2">我们就着手建立了一支全面而专业的团队。</div>
    <SRF position="left">
      <div class="user-box">
        <img class="user-ava" src="@/assets/home/user_ava.png" alt="" />
        <div class="user-info">
          <div class="user-name">闫丽琴</div>
          <div class="user-position">联合创始人</div>
        </div>
      </div>
    </SRF>
  </div>
</template>
<script>
export default {
  data() {
    return {};
  },
  mounted() {
    setTimeout(() => {
      this.$nextTick(() => {
        new this.Typed('#text1', {
          strings: ['从创业之初，'],
          typeSpeed: 100,
        });
        new this.Typed('#text2', {
          strings: ['我们就着手建立了一支全面而专业的团队。'],
          typeSpeed: 60,
        });
      });
    }, 1000);
  },
};
</script>
<style lang="scss" scoped>
@import url('./index.scss');
</style>
